module.exports = __webpack_public_path__ + "img/61.02cb3b56.jpg";